import qs from 'qs';

const queryParams = qs.parse(window.location.search.slice(1));

// showPastItems only make sense for events, but everything also has date filter
// But needs a default
const searchTypes = [
    {
        id: 6,
        index: 'everything',
        optionLabel: 'Everything',
        selectedLabel: 'Everything',
        authRequired: false,
        default: true,
        showPastItems: true,
        facets: [],
    },
    {
        id: 1,
        index: 'members',
        optionLabel: 'Members',
        authRequired: true,
        selectedLabel: 'Members',
        showPastItems: true,
        facets: ['*'],
        // I can't remember why I originally did this, but undoing it might break something else. -Adam
        // facets: [
        //     'business_type',
        //     'designations.value',
        //     'functional_title',
        //     'location.country',
        //     'location.region',
        //     'location.state',
        //     'responsibility',
        // ],
    },
    {
        id: 2,
        index: 'companies',
        optionLabel: 'Companies',
        selectedLabel: 'Companies',
        authRequired: true,
        showPastItems: true,
    },
    {
        id: 5,
        index: 'events',
        optionLabel: 'Events',
        selectedLabel: 'Events',
        authRequired: false,
        showPastItems: queryParams.past === '1',
        facets: [],
    },
    {
        id: 3,
        index: 'articles',
        optionLabel: 'Articles',
        selectedLabel: 'Articles',
        authRequired: false,
        showPastItems: true,
        facets: [],
    },
    {
        id: 7,
        index: 'member_events',
        optionLabel: 'Attendees',
        selectedLabel: 'Attendees',
        authRequired: false,
        showPastItems: true,
        hideOnMainSearch: true,
        facets: [],
    },
    // {
    //     id: 7,
    //     index: 'properties',
    //     optionLabel: 'Properties',
    //     selectedLabel: 'Properties',
    //     authRequired: false,
    //     showPastItems: false,
    // },
];

export default searchTypes;
